var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowSwap(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00994 21.25C8.81994 21.25 8.62994 21.18 8.47994 21.03L3.46994 16.02C3.17994 15.73 3.17994 15.25 3.46994 14.96C3.75994 14.67 4.23994 14.67 4.52994 14.96L9.53994 19.97C9.82994 20.26 9.82994 20.74 9.53994 21.03C9.38994 21.17 9.19994 21.25 9.00994 21.25Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01001 21.25C8.60001 21.25 8.26001 20.91 8.26001 20.5V3.5C8.26001 3.09 8.60001 2.75 9.01001 2.75C9.42001 2.75 9.76001 3.09 9.76001 3.5V20.5C9.76001 20.91 9.42001 21.25 9.01001 21.25Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0099 9.26C19.8199 9.26 19.6299 9.19 19.4799 9.04L14.4699 4.03C14.1799 3.74 14.1799 3.26 14.4699 2.97C14.7599 2.68 15.2399 2.68 15.5299 2.97L20.5399 7.98C20.8299 8.27 20.8299 8.75 20.5399 9.04C20.3899 9.19 20.1999 9.26 20.0099 9.26Z",
    fill: "#292D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.99 21.25C14.58 21.25 14.24 20.91 14.24 20.5V3.5C14.24 3.09 14.58 2.75 14.99 2.75C15.4 2.75 15.74 3.09 15.74 3.5V20.5C15.74 20.91 15.41 21.25 14.99 21.25Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSwap);
export default __webpack_public_path__ + "static/media/arrow-swap.a080bbeb4dac16848d587dabf362ebbe.svg";
export { ForwardRef as ReactComponent };